import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./assets/locales/en.json";
import frTranslation from "./assets/locales/fr.json";
import itTranslation from "./assets/locales/it.json";
import deTranslation from "./assets/locales/de.json";
import esTranslation from "./assets/locales/es.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  it: {
    translation: itTranslation,
  },
  de: {
    translation: deTranslation,
  },
  es: {
    translation: esTranslation,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("language") || "fr",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
